<ng-template pTemplate="header">
  <span class="text-xl font-bold">{{ question_title }}</span>
</ng-template>

<div class="grid align-items-center">
  <div class="col md:col-12">
    <span class="p-input-icon-left ml-auto w-full">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        class="w-full"
        #keywordFilter
        (input)="dt1.filterGlobal([keywordFilter.value], '')"
        placeholder="Cerca..." />
    </span>
  </div>
</div>

<div class="tbl max-w-full">
  <p-table
    [paginator]="true"
    [value]="registries"
    #dt1
    [rows]="25"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [lazy]="true"
    [loading]="loading"
    (onLazyLoad)="loadContacts($event)"
    [(selection)]="selectedRegistries"
    dataKey="id"
    [totalRecords]="totalRecords"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali">
    <ng-template pTemplate="header">
      <tr class="tHead">
        <th></th>
        <th>Nome</th>
        <th>Email</th>
        <th>Città</th>
        <th>VAT</th>
        <th>Tipo</th>
        <th>Servizi</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-d>
      <tr>
        <td *ngIf="pickerType !== 'radio'">
          <p-tableCheckbox [value]="d"></p-tableCheckbox>
        </td>
        <td *ngIf="pickerType === 'radio'">
          <p-radioButton
            [value]="d"
            [inputId]="d.id"
            name="selectedAddressBookControl"
            [formControl]="selectedRegistryControl"></p-radioButton>
        </td>
        <td>{{ d.name }}</td>
        <td>{{ d.email }}</td>
        <td>{{ d.city }}</td>
        <td>{{ d.vat_number }}</td>
        <td>
          <div class="flex flex-wrap gap-1">
            <p-chip *ngFor="let c of d.contact_types">{{ c.type.name }}</p-chip>
            <p-chip *ngIf="d.contact_types.length > 5">...</p-chip>
          </div>
        </td>

        <td>
          <p-accordion
            [activeIndex]="0"
            class="w-full sevices_accordion"
            [activeIndex]="null">
            <p-accordionTab header="Mostra">
              <div *ngFor="let s of d.services">
                <small class="mr-1">{{ s.service_name || '--' }}</small>
                <small class="grey-text">{{ s.category_name || '--' }}</small>
              </div>
            </p-accordionTab>

            <!-- <p-accordionTab *ngFor="let s of d.services">
        <ng-template pTemplate="header">
         <small>{{ s.service_name ||  '--' }}</small>
            <small class="grey-text">{{ s.category_name || '--'}}</small>
        </ng-template>


      </p-accordionTab> -->
          </p-accordion>

          <!-- <div class="flex flex-column" *ngFor="let s of d.services">
            <small>{{ s.service_name ||  '--' }}</small>
            <small class="grey-text">{{ s.category_name || '--'}}</small>
          </div> -->
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td
          colspan="7"
          class="text-center py-2">
          Nessun risultato.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      (onClick)="close()"
      icon="pi pi-times"
      [text]="true"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      icon="pi pi-check"
      (onClick)="save()"
      styleClass="butt"
      [rounded]="true"></p-button>
  </div>
</div>
